import { Toaster } from "components";

import { apiDisability, registrationConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';



export const registrationActions = {
	getClientList,

	addClient,
	updateClient,
	deleteClient,
}

function getClientList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let companyName = func_validation.getObjectPropertyValue(filterOptions, "companyName","");
		let comID = func_validation.getObjectPropertyValue(filterOptions, "comID","");
		let email = func_validation.getObjectPropertyValue(filterOptions, "email","");

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			comName: companyName,
			comID: comID,
			comEmail: email
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetComId', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		});
	}
	
    function request(details) { return { type: registrationConstants.getClientList_request, details }; }
    function success(details) { return { type: registrationConstants.getClientList_success, details }; }
    function failure(error) { return { type: registrationConstants.getClientList_failure, error }; }
}

function addClient(clientInfo) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/ComInfo/ClientRegistration/RegisterCom', JSON.stringify(clientInfo))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully added client"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add client";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: registrationConstants.addClient_request, details }; }
    function success(details) { return { type: registrationConstants.addClient_success, details }; }
    function failure(error) { return { type: registrationConstants.addClient_failure, error }; }
}

function updateClient(clientInfo) {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/updateClient', JSON.stringify(clientInfo))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated client"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update client";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: registrationConstants.updateClient_request, details }; }
    function success(details) { return { type: registrationConstants.updateClient_success, details }; }
    function failure(error) { return { type: registrationConstants.updateClient_failure, error }; }
}

function deleteClient(clients) {
    return dispatch => {
		dispatch(request());

		let clients_validated = func_validation.isArrayNotEmpty(clients)? clients: [];

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/deleteClient', JSON.stringify(clients_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted client(s)"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete client";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: registrationConstants.deleteClient_request, details }; }
    function success(details) { return { type: registrationConstants.deleteClient_success, details }; }
    function failure(error) { return { type: registrationConstants.deleteClient_failure, error }; }
}
